// extracted by mini-css-extract-plugin
export default {"overlay":"BaseDialog_overlay__UzAr4","dialog":"BaseDialog_dialog__-kID6","dialogDescription":"BaseDialog_dialogDescription__9NPsY","heading":"BaseDialog_heading__6SNMX"};